import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-download\">\r\n<circle cx=\"15\" cy=\"15\" r=\"15\" fill=\"#DEDEDE\" />\r\n<path d=\"M17.0114 7H8.14282V23H11.5714V20.7143H10.4285V9.28571H16.0628L19.5714 12.7943V20.7143H18.4285V23H21.8571V11.8457L17.0114 7Z\" fill=\"#999999\" />\r\n<path d=\"M13.8572 15.5715V19.0001H11.5715L15.0001 22.4287L18.4287 19.0001H16.143V15.5715H13.8572Z\" fill=\"#999999\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol